
import HttpRequest from '@/libs/axios'
import config from '@/config'
const baseUrl = config.base

const axios = new HttpRequest(baseUrl)
export default axios



// WEBPACK FOOTER //
// ./src/libs/api.request.js